import axios from "axios";

export const loadNewNotifications = async function () {
    let url = '/user/check-new-notifications'
    return axios.get(url, {
        // params: {
        //   lastRequestAt
        // }
    })
}